<div class="modal-header d-flex align-content-center justify-content-between">
  <h4 class="modal-title" id="modal-basic-title">Modifica metriche - {{ dataTemplate.category ? dataTemplate.category +
    ':' : '' }} {{dataTemplate.templateDriveName}}</h4>
  <button type="button" class="btn close" aria-label="Close" (click)="dismissModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body mx-2 mx-xl-5 my-2">
  <form autocomplete="off">
    <formio [hideLoading]="true" [form]="form$ | async" (formLoad)="formLoaded=true" [submission]="submission"
      [options]="options" (submit)="matricSubmitted($event)"></formio>
  </form>
</div>
<app-loading [fullScreen]="false" [show]="formLoaded === false || submitSubscription?.closed === false"
  class="d-absolute"></app-loading>